<template>
  <div class="container">
    <div class="row mt-4">
      <div class="col">
        <h3>Contact Us</h3>
      </div>
    </div>
    <div class="row mt-2" style="height:1px; background-color:gray;" />
    <div class="row mt-4">
      <div class="col text-left">
        <form @submit.prevent="sendMessage">
          <div class="form-group">
            <h5 class="mb-4">Send us a message</h5>
            <label for="name">Your Name</label>
            <input
              type="text"
              id="name"
              class="form-control"
              v-model="name"
              required
            />
            <label for="fromEmail" class="mt-2">Your Email</label>
            <input
              type="text"
              i="fromEmail"
              class="form-control"
              v-model="fromEmail"
              required
            />
            <label for="message" class="mt-2">Message</label>
            <textarea
              type="text"
              rows="6"
              id="message"
              class="form-control"
              v-model="message"
              required
            />
            <div class="text-center mt-2">
              <button type="submit" class="btn btn-primary">
                Send Message
              </button>
            </div>
          </div>
        </form>
      </div>
      <div class="col text-left ml-4">
        <h5 class="mb-4">Contact us another way</h5>
        <div class="row">
          <div class="col-2 mt-4">
            <i class="material-icons">
              where_to_vote
            </i>
          </div>
          <div class="col-10 mt-4">
            <h6>{{ fgTitle }}</h6>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-2">
            <i class="material-icons">
              local_phone
            </i>
          </div>
          <div class="col-10">
            <p class="mb-0">‭(385) 439-7838‬</p>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-2">
            <i class="material-icons">
              email
            </i>
          </div>
          <div class="col-10">
            <a href="mailto:support@fundsgranted.com‬" class="mb-0"
              >‭support@fundsgranted.com‬</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AWS from "aws-sdk";
import { nittyGritty } from "@/constants/NittyGritty.js";

export default {
  name: "ContactUs",
  data() {
    return {
      name: "",
      fromEmail: "",
      message: "",
      fgTitle: nittyGritty.fundsGrantedTitle
    };
  },
  methods: {
    sendMessage() {
      var view = this;
      view.$store.commit("updateLoading", true);
      AWS.config.credentials = new AWS.CognitoIdentityCredentials(
        view.$store.getters.awsCreds
      );
      AWS.config.region = "us-east-1";
      var lambda = new AWS.Lambda();
      var params = {
        FunctionName: "fundsgrantedsendemail-fg",
        InvocationType: "Event",
        Payload: JSON.stringify({
          emailType: "contactUsMessage",
          fromEmail: view.$data.fromEmail,
          name: view.$data.name,
          message: view.$data.message
        })
      };
      lambda.invoke(params, function(err, data) {
        if (err) {
          console.log(err, err.stack);
          view.$store.commit("updateLoading", false);
          return false;
        }
        // an error occurred
        else {
          if (data.StatusCode == 202) {
            view.$showSnackbar(
              "Your email has been sent and we will get back to you soon.",
              true
            );
            view.$store.commit("updateLoading", false);
          }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
